import { render, staticRenderFns } from "./offerComponent.vue?vue&type=template&id=b73d5f0c&scoped=true"
import script from "./offerComponent.vue?vue&type=script&lang=js"
export * from "./offerComponent.vue?vue&type=script&lang=js"
import style0 from "./offerComponent.vue?vue&type=style&index=0&id=b73d5f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73d5f0c",
  null
  
)

export default component.exports